import type { ChangeEvent, FC } from 'react';
import {
  MEETING_ACCESS_POLICY_OPTIONS,
  MEETING_ACCESS_POLICY_TITLE,
  type MeetingTypeVariant,
} from '../../../../utils/meetingAccessPolicy';
import type { MeetingSecurityOptionsProps } from '../../types';
import RadioOption from './RadioOption';

const MeetingSecurityOptions: FC<MeetingSecurityOptionsProps> = ({
  baseId,
  meetingType,
  isUpdating,
  onMeetingTypeChange,
}) => {
  const handleMeetingTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    onMeetingTypeChange(event.target.value as MeetingTypeVariant);
  };

  return (
    <div className="personal-meetings-modal__security-section">
      <div className="personal-meetings-modal__option-label">{MEETING_ACCESS_POLICY_TITLE}</div>

      {MEETING_ACCESS_POLICY_OPTIONS.map(({ type, label, description }) => (
        <div key={type}>
          <RadioOption
            id={`${baseId}-meeting-type-${type}`}
            name="meeting-type"
            value={type}
            checked={meetingType === type}
            onChange={handleMeetingTypeChange}
            disabled={isUpdating}
            labelClassName="personal-meetings-modal__radio-main-label"
          >
            {label}
          </RadioOption>
          <div className="personal-meetings-modal__radio-description">{description}</div>
        </div>
      ))}
    </div>
  );
};

export default MeetingSecurityOptions;
